/* One free Collector account provider across every collector surface. */
(function(root,factory){
 'use strict';
 if(typeof module==='object'&&module.exports)module.exports={createProvider:factory};
 else if(!root.MMCollectorMembership)root.MMCollectorMembership=factory({window:root,storage:()=>root.localStorage,fetch:root.fetch.bind(root)});
})(typeof window!=='undefined'?window:globalThis,function(options){
 'use strict';options=options||{};
 const base='https://pnlenowzewtmwoyasxbq.supabase.co',key='sb_publishable_MF16GLFsaKp-6p2ivHMJlg_fQ6VEoD4';
 const UUID=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
 const keys=['mmcc-session','mm-collector-cloud-session'];
 let listeners=[],generation=0,pinnedUser=null,pinnedToken=null,pending=null;
 let resumeTimer=null,resumeToken=null,suspended=false,disposed=false;
 const controllers=new Set();
 let state={status:'anonymous',active:false,verified:false,expiresAt:null,checkedAt:null,phase:'collector-only',error:null};
 function storage(){return typeof options.storage==='function'?options.storage():options.storage;}
 function session(){
  for(const name of keys){
   let value;try{value=JSON.parse(storage()?.getItem(name)||'null');}catch(_){return null;}
   if(value===null)continue;
   // Never fall back to a different account when the canonical key is malformed.
   if(!value||typeof value.access_token!=='string'||!/^[A-Za-z0-9._~-]{21,16383}$/.test(value.access_token))return null;
   return {key:name,value};
  }return null;
 }
 function unexpired(s){return s&&(s.expires_at==null||(Number.isFinite(Number(s.expires_at))&&Number(s.expires_at)>Date.now()/1000));}
 function getState(){
  const s=session(),same=!!s&&s.value.access_token===pinnedToken&&unexpired(s.value),c=Object.assign({},state);
  c.accountVerified=!!(!disposed&&!suspended&&same&&pinnedUser&&['member','checking'].includes(state.status));
  c.active=false;c.verified=false;c.expiresAt=null;c.paidValuesLive=false;
  if(pinnedToken&&!same)c.status='anonymous';
  const engine=options.window?.MMCollectorEngine;
  // Known ownership can still protect/recover device-only records during a transient outage.
  // It never grants a new account, paid benefit, or server-side permission.
  c.ownerScopeHash=same&&pinnedUser&&engine?.getOwnerScopeHash?engine.getOwnerScopeHash(pinnedUser):null;
  return c;
 }
 function emit(update){
  state=Object.assign({},state,update,{active:false,verified:false,expiresAt:null});
  const current=getState();listeners.slice().forEach(fn=>{try{fn(current);}catch(_){}});
  if(options.window?.CustomEvent)options.window.dispatchEvent(new options.window.CustomEvent('mm:membership-change',{detail:current}));
  return current;
 }
 function still(attempt,accessToken){return attempt===generation&&session()?.value.access_token===accessToken;}
 async function request(path,accessToken,body){
  const controller=new AbortController();controllers.add(controller);const timer=setTimeout(()=>controller.abort(),15000);
  try{
   const response=await options.fetch(base+path,{method:body?'POST':'GET',cache:'no-store',credentials:'omit',referrerPolicy:'no-referrer',signal:controller.signal,
    headers:{apikey:key,'content-type':'application/json',...(body?{}:{Authorization:'Bearer '+accessToken})},body:body?JSON.stringify(body):undefined});
   return {ok:response.ok,status:response.status,body:await response.json().catch(()=>null)};
  }finally{clearTimeout(timer);controllers.delete(controller);}
 }
 function invalidate(){
  clearTimeout(resumeTimer);resumeTimer=null;
  generation++;pending=null;pinnedUser=null;pinnedToken=null;
  controllers.forEach(c=>c.abort());controllers.clear();
  return emit({status:'anonymous',checkedAt:null,error:null});
 }
 function verify(allowRefresh){
  if(disposed||suspended)return Promise.resolve(getState());
  const initial=session(),original=initial?.value.access_token||null;
  if(pending&&pending.token===original)return pending.promise;
  if(pending){generation++;controllers.forEach(c=>c.abort());controllers.clear();pending=null;}
  const attempt=++generation,job={token:original,promise:null};
  job.promise=Promise.resolve().then(async()=>{
   if(attempt!==generation)return getState();
   if(!initial){pinnedUser=null;pinnedToken=null;return emit({status:'anonymous',checkedAt:new Date().toISOString(),error:null});}
   let current=initial.value,accessToken=original;
   try{
    if(!unexpired(current)){
     if(!allowRefresh||typeof current.refresh_token!=='string'||!current.refresh_token||current.refresh_token.length>16384){
      if(!still(attempt,accessToken))return getState();
      pinnedUser=null;pinnedToken=null;return emit({status:'anonymous',checkedAt:new Date().toISOString(),error:'session_expired'});
     }
     const renewed=await request('/auth/v1/token?grant_type=refresh_token',accessToken,{refresh_token:current.refresh_token});
     if(!still(attempt,accessToken))return getState();
     const b=renewed.body,expires=Number(b?.expires_in);
     if(!renewed.ok||!b||typeof b.access_token!=='string'||!/^[A-Za-z0-9._~-]{21,16383}$/.test(b.access_token)||!Number.isFinite(expires)||expires<=0){
      pinnedUser=null;pinnedToken=null;return emit({status:'anonymous',checkedAt:new Date().toISOString(),error:'session_expired'});
     }
     current={access_token:b.access_token,refresh_token:typeof b.refresh_token==='string'?b.refresh_token:current.refresh_token,expires_at:Math.floor(Date.now()/1000)+expires};
     storage().setItem(initial.key,JSON.stringify(current));accessToken=current.access_token;job.token=accessToken;
    }
    const result=await request('/auth/v1/user',accessToken);
    if(!still(attempt,accessToken))return getState();
    const user=result.body;
    if(!result.ok||!user||!UUID.test(String(user.id||''))||typeof user.email!=='string'||typeof user.email_confirmed_at!=='string'||!Number.isFinite(Date.parse(user.email_confirmed_at))||user.is_anonymous===true){
     pinnedUser=null;pinnedToken=null;return emit({status:'anonymous',checkedAt:new Date().toISOString(),error:'account_required'});
    }
    if(pinnedUser&&pinnedUser!==user.id){pinnedUser=null;pinnedToken=null;return emit({status:'error',checkedAt:new Date().toISOString(),error:'account_changed'});}
    pinnedUser=user.id;pinnedToken=accessToken;
    // Persist only the existing session and the authenticated public user fields.
    storage().setItem(initial.key,JSON.stringify(Object.assign({},current,{user:{id:user.id,email:user.email,email_confirmed_at:user.email_confirmed_at,is_anonymous:false}})));
    return emit({status:'member',checkedAt:new Date().toISOString(),error:null});
   }catch(_){
    if(!still(attempt,accessToken))return getState();
    return emit({status:'error',checkedAt:new Date().toISOString(),error:'account_check_unavailable'});
   }
  }).finally(()=>{if(pending===job)pending=null;});
  pending=job;emit({status:'checking',error:null});return job.promise;
 }
 // Reconcile a legitimate session change or a returning tab without sending another sign-in email.
 // Every identity is still verified by Auth; storage events never grant account or paid access.
 function scheduleResume(force){
  if(disposed||suspended||options.window?.document?.hidden||!session())return;
  const checked=Date.parse(state.checkedAt||''),age=Date.now()-checked;
  const token=session()?.value.access_token;
  if(!force&&Number.isFinite(age)&&age>=0&&age<60000&&(getState().accountVerified||(state.error&&resumeToken===token)))return;
  clearTimeout(resumeTimer);
  const expected=session()?.value.access_token;
  resumeTimer=setTimeout(()=>{
   resumeTimer=null;
   if(disposed||suspended||options.window?.document?.hidden||!expected||session()?.value.access_token!==expected)return;
   resumeToken=expected;
   void verify(true).catch(()=>{});
  },60);
 }
 function onStorage(event){
  if(event.key===null||keys.includes(event.key)){invalidate();scheduleResume(true);}
 }
 function onResume(){scheduleResume(false);}
 function onVisibility(){if(!options.window?.document?.hidden)scheduleResume(false);}
 function onPageHide(){suspended=true;invalidate();}
 function onPageShow(event){suspended=false;scheduleResume(event.persisted===true);}
 if(options.window){
  options.window.MMCollectorPaidValuesLive=false;
  for(const [name,handler]of [['storage',onStorage],['focus',onResume],['pagehide',onPageHide],['pageshow',onPageShow]])options.window.addEventListener?.(name,handler);
  options.window.document?.addEventListener?.('visibilitychange',onVisibility);
 }
 return {version:'2026-10-14.1',getState,check:()=>verify(false),refresh:()=>verify(true),
  requireVerified:async()=>{const s=await verify(true);if(!s.accountVerified)throw Object.assign(new Error('Sign in to your confirmed Collector account before using private collection tools.'),{code:'ACCOUNT_REQUIRED'});return s;},
  requireActive:async()=>{throw Object.assign(new Error('Collector values and paid value tools are not part of the current launch.'),{code:'VALUES_NOT_LIVE'});},
  subscribe:fn=>{if(typeof fn!=='function')throw new TypeError('A listener is required.');listeners.push(fn);return()=>{listeners=listeners.filter(x=>x!==fn);};},
  invalidate,isAllowed:capability=>['add','lists'].includes(capability)||(['sync','account','community'].includes(capability)&&getState().accountVerified===true),
  dispose:()=>{
   disposed=true;invalidate();listeners=[];
   for(const [name,handler]of [['storage',onStorage],['focus',onResume],['pagehide',onPageHide],['pageshow',onPageShow]])options.window?.removeEventListener?.(name,handler);
   options.window?.document?.removeEventListener?.('visibilitychange',onVisibility);
  }};
});
